import cryptoJS from 'crypto-js';
class EncryptAesService {
  encryptText(plainText: string) {
    const key = cryptoJS.enc.Utf8.parse('SWALME82WTFVA8@1');
    const iv = cryptoJS.enc.Utf8.parse('MYSECIV$ISHE%$@A');
    const encryptedText = cryptoJS.AES.encrypt(cryptoJS.enc.Utf8.parse(plainText), key, {
      iv,
      keySize: 128 / 8,
      mode: cryptoJS.mode.CBC,
      padding: cryptoJS.pad.Pkcs7,
    });
    return encryptedText;
  }
}
export default new EncryptAesService();
